import { BaseEventProps } from "../../types";

export type EventProps = BaseEventProps;

export enum MediatorEventType {
  BET_ON_MOBILE_MODAL_VIEWED = "BET_ON_MOBILE_MODAL_VIEWED",
  BET_ON_MOBILE_MODAL_CTA_CLICKED = "BET_ON_MOBILE_MODAL_CTA_CLICKED"
}
